import Vue from 'vue'
import objectFitImages from 'object-fit-images'
import { getImageWithSize } from 'lib/util'
import inViewport from 'in-viewport'

Vue.component('vue-image', {
  props: {
    src: String,
    sources: Array,
    alt: String,
    css: String,
    size: Number,
    loader: {
      type: Boolean,
      default: false
    },
    spinner: {
      type: Boolean,
      default: true
    },
    spinnerSize: {
      type: String,
      default: 'lg'
    },
    scale: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      mainImageSrc: '',
      secondaryImgSrc: '',
      isInViewport: false,
      states: {
        isLoaded: false
      }
    }
  },
  computed: {
    imgClasses () {
      return this.states.isLoaded ? 'is-loaded' : ''
    },
    parts () {
      const arr = this.src.split(new RegExp(`.(jpg|jpeg|png|gif)`))
      console.log(arr)

      return {
        originalPath: arr[0],
        filePath: arr[0].replace(new RegExp(`_[0-9]*x`), ''),
        ext: arr[1],
        query: arr[2]
      }
    },
    blurSrc () {
      return getImageWithSize(this.src, 50)
    },
    blurSrcStyle () {
      return `url(${this.blurSrc})`
    },
    sizeSrc () {
      return this.size ? getImageWithSize(this.src, this.size) : this.src
    },
    spinnerActive () {
      return !this.states.isLoaded
    },
    spinnerClass () {
      return `spinner spinner--abs z1 spinner--${this.spinnerSize}`
    }
  },
  mounted () {
    inViewport(this.$el, () => {
      this.isInViewport = true
    })
    if (this.loader) {
      this.loadImage(this.blurSrc)
    }
  },
  watch: {
    isInViewport (value) {
      if (value) {
        this.$nextTick(() => {
          if (typeof this.$refs['source'] !== 'undefined' && this.$refs['source'].length > 0) {
            this.getSrcset(this.$refs['source'])
          }
        })
      }
    }
  },
  methods: {
    onLoaded () {
      this.states.isLoaded = true
      const { image } = this.$refs
      const { scale } = this

      if (!image) {
        return
      }

      image.setAttribute('width', image.width * scale)
      image.setAttribute('height', image.height * scale)
    },
    getSizeSrc (size) {
      // const { filePath, ext, query } = this.parts
      return getImageWithSize(this.src, size)
    },
    loadImage (src, onLoad = () => {}) {
      const img = new Image()

      img.onload = onLoad
      img.src = src
      objectFitImages()
    },
    getSrcset (sources) {
      for (let source of sources) {
        if (source.hasAttribute('data-srcset')) {
          source.setAttribute('srcset', source.getAttribute('data-srcset'))
          source.removeAttribute('data-srcset')
        }
      }
    }
  },
  template: `
    <transition-group name="fade" tag="picture" :class="['img', css, imgClasses]">
      <template v-if="isInViewport">
        <source
          v-for="(source, i) in sources"
          ref="source"
          :key="source['media']"
          :media="source['media']"
          :data-srcset="source['srcset']">
        <img
          ref="image"
          class="img__el"
          :src="sizeSrc"
          :alt="alt ? alt : ''"
          :key="src"
          @load="onLoaded" />
      </template>
      <i
        v-if="loader"
        class="img__loader"
        :key="0"></i>
      <i
        v-if="spinner"
        :class="[spinnerClass, { 'is-active' : spinnerActive }]"
        :key="spinnerActive"></i>
    </transition-group>
  `
})
